import React, { useEffect, useState } from 'react';
import { fetchYoutubeVideos } from '../../lib/api';
import { Youtube, Play } from 'lucide-react';

const YouTubeSection = () => {
  const [data, setData] = useState(null);
  const [playing, setPlaying] = useState(null);

  useEffect(() => { fetchYoutubeVideos().then(setData).catch(() => setData(null)); }, []);

  if (!data || !data.videos?.length) return null;

  return (
    <section id="videos" className="py-20 bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-orange-400">Watch & Learn</span>
            <h2 className="mt-2 text-2xl sm:text-3xl font-extrabold">Latest from our YouTube channel</h2>
          </div>
          <a href={data.channel_url} target="_blank" rel="noreferrer" data-testid="youtube-subscribe-btn"
            className="inline-flex items-center gap-2 rounded-full bg-red-600 hover:bg-red-700 text-white text-sm font-bold px-5 py-2.5 transition-colors">
            <Youtube className="h-4 w-4" /> Subscribe
          </a>
        </div>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="youtube-grid">
          {data.videos.slice(0, 6).map((v) => (
            <div key={v.id} className="rounded-2xl overflow-hidden border border-white/10 bg-white/5">
              {playing === v.id ? (
                <iframe
                  title={v.title}
                  src={`https://www.youtube.com/embed/${v.id}?autoplay=1`}
                  className="w-full aspect-video border-0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button onClick={() => setPlaying(v.id)} data-testid={`youtube-play-${v.id}`} className="group relative block w-full aspect-video">
                  <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover" loading="lazy" />
                  <span className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/20 transition-colors">
                    <span className="h-14 w-14 rounded-full bg-red-600 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="h-6 w-6 text-white fill-white ml-0.5" />
                    </span>
                  </span>
                </button>
              )}
              <div className="p-4 text-sm font-semibold line-clamp-2">{v.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default YouTubeSection;
